export const filterNutritionPlansBySearchTerm = (
  nutritionPlans,
  searchTerm = ""
) => {
  if (!Array.isArray(nutritionPlans)) {
    return [];
  }

  const normalizedSearchTerm =
    typeof searchTerm === "string" ? searchTerm.trim().toLowerCase() : "";

  if (!normalizedSearchTerm) {
    return nutritionPlans;
  }

  return nutritionPlans.filter((nutritionPlan) => {
    const name =
      typeof nutritionPlan?.name === "string" ? nutritionPlan.name : "";

    return name.toLowerCase().includes(normalizedSearchTerm);
  });
};
